import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Flex, RadioButtonGroup, RadioButton, theme } from '../../../../ui';
import { getDarkerThemeColor } from '../../../../ui/theme/colors';
import styled from 'styled-components';

const FlexStyled = styled(Flex)`
  .MuiFormGroup-root{
    gap:14px;
  }
`;

const SingleChoiceType = ({ results, data, onSubmit, themeColor, onAnswerResult }) => {
  const { t } = useTranslation();

  const [answer, setAnswer] = useState();
  const defaultValue = results.length >= 0 && results.find(result => result.taskId === data.taskId)?.value[0];

  const handleSubmit = useCallback(()=>{
    // cant use !! because zero is considered false. so just check for undefined
    if (typeof answer !== 'undefined') {
      onSubmit([answer]);

      // Check if answer is correct and notify parent
      const correctAnswer = data.correctResponse?.value || [];
      const isCorrect = correctAnswer.includes(answer);
      if (onAnswerResult) onAnswerResult({ isCorrect });
    }
  },[answer, onSubmit, data.correctResponse, onAnswerResult]);

  const handleClick = useCallback((e)=>{
    setAnswer(Number(e.target.value));
  }, [setAnswer]);

  return (
    <FlexStyled width='100%' gap='10' direction='column'>
      <RadioButtonGroup
        fullWidth={true}
        handleChange={handleClick}
        selectedValue={answer ?? defaultValue}
      >
        {data.caption?.items?.map((option, index) => (
          <RadioButton
            key={index}
            value={index}
            labelText={option}
            themeColor={getDarkerThemeColor(themeColor)}
          />
        ))}
      </RadioButtonGroup>
      <Flex justify='flex-end' alignSelf='flex-end'>
        <Button
          $variant='customized'
          $bgcolor={getDarkerThemeColor(themeColor) || theme.colors.PRIMARY}
          onClick={handleSubmit}
          disabled={typeof answer === 'undefined' && typeof defaultValue === 'undefined'}
        >
          {t('globals.submit')}
        </Button>
      </Flex>
    </FlexStyled>
  )
};

export default SingleChoiceType;
